export default __webpack_public_path__ + "static/media/tek.300248fe.svg";